<template>
  <div style="padding: 20px">
    <div class="container">
      <!-- header -->
      <header>
        <div
          :class="
            listSelectHidden
              ? 'headerContainer headerHidden'
              : 'headerContainer'
          "
        >
          <div style="display: flex; flex: 5; flex-wrap: wrap">
            <div class="searchItem">
              <span class="searchText">资源名称:</span>
              <el-input
                placeholder="试着输入点什么"
                prefix-icon="el-icon-search"
                v-model="name"
                size="small"
                style="width: 150px; margin-left: 10px"
                @keydown.enter.native="search"
              >
              </el-input>
            </div>
            <div class="searchItem">
              <span class="searchText">资源类型:</span>
              <el-select
                v-model="type"
                placeholder="请选择"
                style="width: 150px; margin-left: 10px"
                size="small"
                filterable
                clearable
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
            <div class="searchItem">
              <span class="searchText">资源状态:</span>
              <el-select
                v-model="wallpaperStatus"
                placeholder="请选择"
                style="width: 150px; margin-left: 10px"
                size="small"
              >
                <el-option
                  v-for="item in wallpaperStatusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="searchItem">
              <span class="searchText">认证状态:</span>
              <el-select
                v-model="authType"
                placeholder="请选择"
                style="width: 150px; margin-left: 10px"
                size="small"
              >
                <el-option
                  v-for="item in authTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="searchItem">
              <span class="searchText">设计师类型:</span>
              <el-select
                v-model="designerType"
                placeholder="请选择"
                style="width: 150px; margin-left: 10px"
                size="small"
              >
                <el-option
                  v-for="item in designerTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="searchItem">
              <span class="searchText">分类:</span>
              <el-select
                v-model="categoryType"
                placeholder="请选择"
                style="width: 150px; margin-left: 10px"
                size="small"
                filterable
                clearable
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="searchItem">
              <span class="searchText">设计师:</span>
              <el-select
                v-model="authorId"
                placeholder="请选择设计师"
                style="width: 150px; margin-left: 10px"
                filterable
                size="small"
                clearable
              >
                <el-option
                  v-for="item in designerOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="searchItem">
              <span class="searchText">数据集:</span>
              <el-select
                v-model="dataSetId"
                placeholder="请选择"
                style="width: 150px; margin-left: 10px"
                size="small"
                filterable
                clearable
              >
                <el-option
                  v-for="item in dataOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="searchItem">
              <span class="searchText">创建时间:</span>
              <el-date-picker
                style="margin-left: 10px"
                size="small"
                v-model="createTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
          </div>
          <div style="display: flex; flex: 2; flex-wrap: wrap">
            <div class="searchItem">
              <el-button type="primary" size="small" @click="search"
                >查询</el-button
              >
              <el-button
                type="info"
                size="small"
                @click="
                  name = '';
                  type = '';
                  wallpaperStatus = '';
                  designerType = '';
                  authType = '';
                  authorId = '';
                  dataSetId = '';
                  createTime = '';
                "
                >重置</el-button
              >
            </div>
            <div class="searchItem">
              <router-link :to="{ path: `/resource/wallpaper/create` }">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-plus"
                  v-check-role
                  >新增</el-button
                >
              </router-link>
            </div>
            <div
              v-check-role
              class="selectDownIconContainer searchItem"
              @click="switchIcon"
            >
              <template v-if="listSelectHidden">
                <span>展开</span>
                <i class="el-icon-arrow-down"></i>
              </template>
              <template v-else>
                <span>收起</span>
                <i class="el-icon-arrow-up"></i>
              </template>
            </div>
            <div class="searchItem">
              <el-button
                type="primary"
                size="small"
                @click="uploadExcelDialog = true"
                v-check-role
                >导入</el-button
              >
              <el-button type="primary" size="small" @click="exportExcel"
                >导出</el-button
              >
              <el-button
                type="danger"
                size="small"
                @click="batchDeleteWallpapers"
                v-check-role
                >批量删除</el-button
              >
            </div>
            <div
              v-check-else-role
              class="selectDownIconContainer searchItem"
              @click="switchIcon"
            >
              <template v-if="listSelectHidden">
                <span>展开</span>
                <i class="el-icon-arrow-down"></i>
              </template>
              <template v-else>
                <span>收起</span>
                <i class="el-icon-arrow-up"></i>
              </template>
            </div>
          </div>
        </div>
      </header>

      <!-- main -->
      <div style="margin-bottom: 20px" v-if="!loading">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          :row-key="getRowKey"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
          >
          </el-table-column>
          <el-table-column
            label="壁纸名称"
            prop="wallpaperName"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <word-copy>{{ scope.row.wallpaperName }}</word-copy>
            </template>
          </el-table-column>
          <el-table-column
            prop="thumbUrl"
            label="缩略图"
            align="center"
            show-overflow-tooltip
            width="70px"
          >
            <template slot-scope="scope">
              <img v-lazy="scope.row.thumbUrl" alt="icon" class="tableIcon" />
            </template>
          </el-table-column>
          <el-table-column
            prop="wallpaperType"
            label="资源类型"
            show-overflow-tooltip
            align="center"
          />
          <el-table-column
            prop="designerType"
            label="设计师类型"
            show-overflow-tooltip
            align="center"
          />
          <el-table-column
            prop="isAuth"
            label="认证状态"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.isAuth === 0 ? "未认证" : "已认证" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="已关联分类" align="center" width="120px">
            <template slot-scope="scope">
              <div class="tagContainer">
                <router-link
                  v-for="(item, index) in scope.row.categorySimpleVOList"
                  :key="index"
                  :to="{ path: '/collection/classify/info/' + item.id }"
                  class="tagLinkContainer"
                >
                  <div
                    class="tagItem"
                    :style="`background:${colorMap[item.name]}`"
                  >
                    {{ item.name }}
                  </div>
                </router-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="defaultLockGroupName"
            label="关联解锁"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <div class="mockContainer">
                <el-input
                  disabled
                  v-model="scope.row.defaultLockGroupName"
                  size="mini"
                  class="loackInput"
                  style="width: 70%"
                >
                </el-input>
                <div @click="showLockType(scope.row.id)" class="mockButton">
                  ...
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="onOrOff"
            label="状态"
            align="center"
            width="100px"
          >
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.onOrOff === 11"
                placement="top-start"
                title=""
                width="200"
                trigger="hover"
                :content="scope.row.comment"
              >
                <div slot="reference">
                  <div
                    :class="
                      scope.row.onOrOff === 1
                        ? 'statusDiv online'
                        : scope.row.onOrOff === 0
                        ? 'statusDiv offline'
                        : scope.row.onOrOff === 2
                        ? 'statusDiv userCancel'
                        : scope.row.onOrOff === 3
                        ? 'statusDiv userDelete'
                        : scope.row.onOrOff === 10
                        ? 'statusDiv loadding'
                        : 'statusDiv error'
                    "
                  ></div>
                  <span>{{
                    scope.row.onOrOff === 1
                      ? "上线"
                      : scope.row.onOrOff === 0
                      ? "下线"
                      : scope.row.onOrOff === 2
                      ? "用户取消"
                      : scope.row.onOrOff === 3
                      ? "用户删除"
                      : scope.row.onOrOff === 10
                      ? "资源处理中"
                      : "资源处理失败"
                  }}</span>
                </div>
              </el-popover>
              <div v-else>
                <div
                  :class="
                    scope.row.onOrOff === 1
                      ? 'statusDiv online'
                      : scope.row.onOrOff === 0
                      ? 'statusDiv offline'
                      : scope.row.onOrOff === 2
                      ? 'statusDiv userCancel'
                      : scope.row.onOrOff === 3
                      ? 'statusDiv userDelete'
                      : scope.row.onOrOff === 10
                      ? 'statusDiv loadding'
                      : 'statusDiv error'
                  "
                ></div>
                <span>{{
                  scope.row.onOrOff === 1
                    ? "上线"
                    : scope.row.onOrOff === 0
                    ? "下线"
                    : scope.row.onOrOff === 2
                    ? "用户取消"
                    : scope.row.onOrOff === 3
                    ? "用户删除"
                    : scope.row.onOrOff === 10
                    ? "资源处理中"
                    : "资源处理失败"
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="100px"
            label="创建时间"
            prop="createTime"
            align="center"
          />
          <el-table-column
            width="100px"
            label="更新时间"
            prop="updateTime"
            align="center"
          />
          <el-table-column
            label="操作"
            align="center"
            width="240px"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="copyKey(scope.row.key)"
                >复制key</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="goInfo(scope.row.id)"
                :disabled="scope.row.onOrOff === 10"
                >查看</el-button
              >
              <el-button
                type="danger"
                size="mini"
                v-check-role
                :disabled="scope.row.onOrOff === 10"
                @click="deleteWallpaperRow(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-skeleton :rows="8" animated v-else />
      <!-- footer -->
      <div class="footerContainer">
        <div style="color: #a1a1a1">
          共 {{ total }} 条记录 第 {{ currentPage }} / {{ currentPageSize }} 页
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next,sizes,jumper"
          :total="total"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="currentPageSize"
          :current-page.sync="currentPage"
        />
      </div>
    </div>
    <el-dialog
      title="关联解锁方式"
      :visible.sync="dialogVisible"
      width="30%"
      top="25vh"
      :before-close="handleClose"
    >
      <div v-loading="dialogLoading">
        <el-form disabled :model="form" label-position="top" size="mini">
          <el-form-item label="默认解锁方式">
            <el-input v-model="form.defaultUnlockType"></el-input>
          </el-form-item>
          <el-form-item label="数据集解锁方式(选填)">
            <div
              v-for="(item, index) in form.data_unlock_type_list"
              :key="index"
              style="display: flex; margin-bottom: 5px"
            >
              <el-input
                v-model="item.lockGroupName"
                style="margin-right: 20px"
              ></el-input>
              <el-input v-model="item.dataSetName"></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleClose">取 消</el-button>
        <el-button size="mini" type="primary" @click="handleClose"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <upload-excel-component
      :on-success="uploadExcelSuccess"
      :centerDialogVisible.sync="uploadExcelDialog"
    />
  </div>
</template>

<script>
import {
  getWallpaperList,
  getWallpaperById,
  batchDeleteWallpaper,
  deleteWallpaperById,
} from "../../../api/wallpaperManage";
import UploadExcelComponent from "../../../components/uploadExcel/index.vue";
import {
  getAllCategory,
  exportResourceList,
  importResourceList,
  getAllDataList,
} from "../../../api/comment";
import { getDesignerList } from "../../../api/designerManage";
export default {
  name: "list",
  data() {
    return {
      name: "",
      type: "",
      authorId: "",
      tableData: [],
      currentPage: 1,
      currentPageSize: 10,
      total: 0,
      loading: false,
      typeOptions: [
        "静态壁纸资源",
        "视频壁纸资源",
        "4D Parallax壁纸资源",
        "重力壁纸资源",
        "动画壁纸资源",
        "交互壁纸资源",
        "壁纸合集资源",
        "桌面宠物",
        "毛玻璃",
        "时钟壁纸",
        "3d重力",
        "联系人海报资源",
        "游戏壁纸资源",
        "来电秀壁纸资源",
        "实况壁纸资源",
        "unity壁纸",
        "TV屏保",
        "live壁纸",
        "OS26景深壁纸资源",
        "flip",
        "AIGC",
      ],
      wallpaperStatus: "",
      wallpaperStatusOptions: [
        { label: "上线", value: "1" },
        { label: "下线", value: "0" },
        { label: "用户取消", value: "2" },
        { label: "用户删除", value: "3" },
        { label: "资源处理中", value: "10" },
        { label: "资源处理失败", value: "11" },
      ],
      colorMap: {},
      form: {},
      dialogVisible: false,
      dialogLoading: false,
      designerType: "",
      designerTypeOptions: [
        { label: "User", value: "User" },
        { label: "UGC", value: "UGC" },
      ],
      authType: "",
      authTypeOptions: [
        { label: "未认证", value: "0" },
        { label: "已认证", value: "1" },
      ],
      listSelectHidden: true,
      multipleSelection: [],
      uploadExcelDialog: false,
      categoryOptions: [],
      categoryType: "",
      currentPageActive: [],
      designerOptions: [],
      dataSetId: "",
      createTime: "",
      dataOptions: [],
    };
  },
  components: {
    UploadExcelComponent,
  },
  created() {
    this.getList();
    this.getCategory();
    this.getAllDesigner();
    this.getAllDataSet();
    this.againList = setInterval(() => {
      this.getListAgain();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.againList);
  },
  methods: {
    //获取所有的数据集
    getAllDataSet() {
      getAllDataList().then((res) => {
        if (res.success) {
          this.dataOptions = res.data;
        }
      });
    },
    copyKey(text) {
      if (navigator.clipboard) {
        // clipboard api 复制
        navigator.clipboard.writeText(text);
      } else {
        var textarea = document.createElement("textarea");
        document.body.appendChild(textarea);
        // 隐藏此输入框
        textarea.style.position = "fixed";
        textarea.style.clip = "rect(0 0 0 0)";
        textarea.style.top = "10px";
        // 赋值
        textarea.value = text;
        // 选中
        textarea.select();
        // 复制
        document.execCommand("copy", true);
        // 移除输入框
        document.body.removeChild(textarea);
      }
      this.$message.info("key已复制到剪切板中");
    },
    getAllDesigner() {
      getDesignerList(
        { pageNum: "", pageSize: "", name: "", type: "" },
        0
      ).then((res) => {
        this.designerOptions = res.data;
      });
    },
    getRowKey(row) {
      return row.id;
    },
    getCategory() {
      getAllCategory()
        .then((res) => {
          if (res.success) {
            this.categoryOptions = res.data;
          }
        })
        .catch((err) => {
          this.$message({
            showClose: true,
            duration: 5000,
            type: "info",
            message: err,
          });
        });
    },
    exportExcel() {
      const keyList = this.multipleSelection.map((item) => {
        return item.key;
      });
      var resData = {
        keySet: keyList,
        resourceType: 0,
        wallpaperName: this.name,
        wallpaperType: this.type,
        wallpaperStatus: this.wallpaperStatus,
        isAuth: this.authType,
        designerType: this.designerType,
        categoryId: this.categoryType,
        dataSetId: this.dataSetId,
        createTimeStart: this.createTime ? this.createTime[0] : "",
        createTimeEnd: this.createTime ? this.createTime[1] : "",
      };
      //拿到keyList发请求,然后等着结果,下载返回结果的资源
      exportResourceList(resData)
        .then((res) => {
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          let href = window.URL.createObjectURL(blob); //创建下载的链接
          let downloadElement = document.createElement("a");
          downloadElement.href = href;
          downloadElement.download =
            decodeURI(
              res.headers["content-disposition"].split("filename=")[1]
            ) || ""; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          let that = this;
          setTimeout(function () {
            that.multipleSelection = [];
            that.$refs.multipleTable.clearSelection();
          }, 100);
        })
        .catch((err) => {
          this.$message({
            showClose: true,
            duration: 5000,
            type: "info",
            message: err,
          });
        });
    },
    uploadExcelSuccess({ results, header }, radio, file) {
      // 查找
      if (radio == "1") {
        if (header.includes("key")) {
          this.$message({
            type: "success",
            message: "导入成功",
          });
          this.multipleSelection = results;
          this.checkedElementCheck();
        } else {
          this.$message({
            showClose: true,
            duration: 5000,
            type: "info",
            message: "必须包含“key”字段～",
          });
        }
      } else {
        // 覆盖 刷新列表
        let form = new FormData();
        form.append("file", file);
        form.append("resourceType", 0);
        importResourceList(form)
          .then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "导入成功",
              });
              this.getList();
              this.$nextTick(() => {});
              let that = this;
              setTimeout(function () {
                that.multipleSelection = [];
              }, 100);
            } else {
              this.$message({
                showClose: true,
                duration: 5000,
                type: "info",
                message: res.data.errMessage,
              });
            }
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              duration: 5000,
              type: "info",
              message: err,
            });
          });
      }
    },
    handleSelectionChange(val) {
      let newItem = [];
      let deleteItem = [];
      let keys = this.multipleSelection.map((e) => e.key);
      let valKeys = val.map((e) => e.key);

      let deleteKeys = [];
      //新增的
      val.forEach((e) => {
        if (!keys.includes(e.key)) {
          newItem.push(e);
        }
      });
      //删除的
      this.currentPageActive.forEach((e) => {
        if (!valKeys.includes(e.key)) {
          deleteItem.push(e.key);
        }
      });

      var filtered = this.multipleSelection.filter(function (
        value,
        index,
        arr
      ) {
        return !deleteItem.includes(value.key);
      });
      filtered.push(...newItem);
      this.multipleSelection = filtered;
      let that = this;
      setTimeout(() => {
        that.currentPageActive = val;
      }, 100);
    },
    checkedElementCheck() {
      var that = this;
      var keyItemList = [];
      this.multipleSelection.forEach((element) => {
        let keyItem = [];
        this.tableData.forEach((item) => {
          // 通过excel上传的key值
          if (element.id == undefined) {
            if (item.key == element.key) {
              element = item;
              keyItem.push(item);
            }
          } else {
            // 自己手动选择的key
            if (item.key == element.key) {
              keyItem.push(item);
            }
          }
        });

        keyItemList.push(...keyItem);
      });
      if (keyItemList.length > 0) {
        keyItemList.forEach((e) => {
          setTimeout(function () {
            that.$refs.multipleTable.toggleRowSelection(e, true);
          }, 100);
        });
      }
      this.currentPageActive = keyItemList;
    },
    //重新获取列表数据
    getList() {
      this.loading = true;
      getWallpaperList({
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize,
        name: this.name,
        type: this.type,
        wallpaperStatus: this.wallpaperStatus,
        isAuth: this.authType,
        designerType: this.designerType,
        categoryId: this.categoryType,
        authorId: this.authorId,
        dataSetId: this.dataSetId,
        createTimeStart: this.createTime ? this.createTime[0] : "",
        createTimeEnd: this.createTime ? this.createTime[1] : "",
      })
        .then((res) => {
          if (res.success) {
            this.total = res.data.total;
            this.tableData = res.data.wallpaperVOList;
            this.getColorList(res.data.allCategoryName || []);
            this.checkedElementCheck();
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getListAgain() {
      getWallpaperList({
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize,
        name: this.name,
        type: this.type,
        wallpaperStatus: this.wallpaperStatus,
        isAuth: this.authType,
        designerType: this.designerType,
        categoryId: this.categoryType,
        authorId: this.authorId,
        dataSetId: this.dataSetId,
        createTimeStart: this.createTime ? this.createTime[0] : "",
        createTimeEnd: this.createTime ? this.createTime[1] : "",
      })
        .then((res) => {
          if (res.success) {
            this.total = res.data.total;
            this.tableData = res.data.wallpaperVOList;
            this.getColorList(res.data.allCategoryName || []);
            this.checkedElementCheck();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //header-依据查询条件进行查询
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //footer-大小改变
    handleSizeChange(val) {
      this.currentPageSize = val;
      this.$nextTick(() => {
        this.getList();
      });
    },
    //footer-当前页数改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    //生产随机颜色
    getRandomColor() {
      return (
        "#" +
        ("00000" + ((Math.random() * 0x1000000) << 0).toString(16)).substr(-6)
      );
    },
    //生成颜色集
    getColorList(list) {
      list.forEach((e) => {
        this.colorMap[e] = this.getRandomColor();
      });
    },
    //显示解锁type
    showLockType(id) {
      this.dialogVisible = true;
      this.dialogLoading = true;
      getWallpaperById({ id })
        .then((res) => {
          if (res.success) {
            this.form.defaultUnlockType = res.data.defaultLockGroupName;
            this.form.data_unlock_type_list = res.data.wallpaperLockGroupVOList;
          }
        })
        .finally(() => {
          this.dialogLoading = false;
        });
    },
    //关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.form = {};
    },
    //去info页面
    goInfo(id) {
      window.open(`/#/resource/wallpaper/info/${id}`, "_blank");
      // this.$router.push(`/resource/wallpaper/info/${id}`)
    },
    deleteWallpaperRow(row) {
      if (!row || row.id == null) {
        this.$message.warning("资源 ID 缺失，无法删除");
        return;
      }
      this.$confirm("此操作将删除该资源, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => deleteWallpaperById({ id: row.id }))
        .then((res) => {
          if (res && res.success) {
            this.$message.success("删除成功");
            // Excel 导入的勾选项往往只有 key、无 id，用 key 过滤才能正确剔除
            this.multipleSelection = this.multipleSelection.filter(
              (item) => item.key !== row.key
            );
            this.getList();
          }
        })
        .catch(() => {});
    },
    switchIcon() {
      this.listSelectHidden = !this.listSelectHidden;
    },
    batchDeleteWallpapers() {
      const idList = this.multipleSelection.map((item) => {
        return item.id;
      });
      batchDeleteWallpaper({ ids: idList })
        .then((res) => {
          if (res.success) {
            this.$message({
              type: "info",
              message: res.data.message,
            });
            this.getList();
            let that = this;
            setTimeout(function () {
              that.multipleSelection = [];
              that.$refs.multipleTable.clearSelection();
            }, 100);
          } else {
            this.$message({
              showClose: true,
              duration: 5000,
              type: "info",
              message: res.errMessage,
            });
          }
        })
        .catch((err) => {
          this.$message({
            showClose: true,
            duration: 5000,
            type: "info",
            message: err,
          });
        });
    },
  },
};
</script>

<style scoped>
.container {
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.2);
  padding: 20px;
  height: auto;
}

.headerContainer {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.headerHidden {
  height: 45px;
  overflow: hidden;
}

.searchItem {
  margin-right: 20px;
  margin-bottom: 20px;
}

.selectItem {
  margin-right: 10px;
}

.searchText {
  font-size: 14px;
}

.tableIcon {
  height: 45px;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.2);
}

.tagContainer {
  display: flex;
  flex-direction: column;
  max-height: 55px;
  overflow: auto;
}

.tagItem {
  padding: 8 10px;
  box-sizing: border-box;
  border-radius: 5px;
  color: #ffffff;
  font-size: 12px;
}

.footerContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.statusDiv {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  margin-right: 5px;
  display: inline-block;
}

.online {
  background-color: #18a758;
}

.offline {
  background-color: #bfbfbf;
}

.userCancel {
  background-color: #d6fc04;
}

.userDelete {
  background-color: #c57575;
}

.loadding {
  background-color: blue;
}

.error {
  background-color: red;
}

.tagLinkContainer {
  text-decoration: none;
  margin-bottom: 5px;
}

.tagLinkContainer:last-child {
  margin-bottom: 0;
}

.mockContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.mockButton {
  position: absolute;
  right: 0;
  height: 28px;
  line-height: 20px;
  width: 30px;
  color: #ffffff;
  background-color: #46a0fc;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
}

.selectDownIconContainer {
  color: #46a0fc;
  cursor: pointer;
  height: 32px;
  line-height: 32px;
}

::v-deep .el-input.is-disabled .el-input__inner {
  padding-left: 10px;
}

::v-deep .el-pagination__jump {
  margin-left: -5px;
}

::v-deep .el-dialog__body {
  padding: 10px 20px;
}
</style>
